export default __webpack_public_path__ + "static/22-cf74060a4951b1ecc461a3dd5ff1a8c7.png";